import React from 'react';

import { useTranslation } from 'react-i18next';

import { StyledP } from './styles';

export const GroupFilterNoResults = () => {
    const { t } = useTranslation(['groups']);

    return <StyledP>{t('groups_filter_collections_no_results')}</StyledP>;
};
